<template>
  <section class="bd-content">
    <!-- :style="`height: ${getScrollHeight()}`" -->
    <div class="bd-example vue-example vue-example-b-embed">
      <div class="embed-responsive embed-responsive-16by9">
        <youtube :video-id="videoId" class="wd-100p"></youtube>
      </div>
    </div>
  </section>
</template>
<script>
import { getIdFromUrl } from "vue-youtube";

export default {
  name: "detail",
  props: {
    url: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      videoId: null
    };
  },

  mounted() {
    try {
      this.videoId = getIdFromUrl(this.url);
    } catch (err) {
      // eslint-disable-next-line
      //console.log(err);
    }
  },
  methods: {
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    }
  }
};
</script>
